import { render, staticRenderFns } from "./ViewWSU.vue?vue&type=template&id=97e7f79e&"
import script from "./ViewWSU.vue?vue&type=script&lang=js&"
export * from "./ViewWSU.vue?vue&type=script&lang=js&"
import style0 from "./ViewWSU.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports